import angular from 'angular';

export default class ModalKformBuilderParametersController {
	/* @ngInject */
	/**
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {any} Notification
	 * @param {any} parameters
	 */
	constructor(
		$translate,
		$uibModalInstance,
		Notification,
		parameters,
	) {
		this.$uibModalInstance = $uibModalInstance;
		this.params = angular.isObject(parameters) ? angular.copy(parameters) : {};

		this.options = {
			mode:    'tree',
			modes:   [
				'code',
				'form',
				'text',
				'tree',
				'view',
			],
			onError: (/** @type {any} */ error) => {
				Notification.warning({
					title:     $translate.instant('error.title'),
					message:   error.toString(),
				});
			},
		};
	}

	submit() {
		this.$uibModalInstance.close(this.params);
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}
}
